import * as React from "react";
import { Routes, Route, useLocation, useNavigate, useParams } from "react-router-dom";
import { om2confirm } from "omni-campaign-ui";

// Shared components and utilities
import { 
    LoaderComponent, 
    OmniIconComponent, 
    NoDataComponent, 
    OmniTooltipNextComponent, 
    Constants, 
    taxonomyTypes, 
    env, 
    CookieService, 
    AlertMessagesService, 
    MediaOpsService, 
    Utils,
    initAmplitude, 
    trackEvent, 
    identifyUser,
    NavigationStack
} from "./shared";
// Feature imports - Campaigns
import { 
    CampaignDetailComponent,
    CampaignDetailComponentV2,
    CampaignTableAgGridV1,
    CampaignTableAgGridV2,
    ChildCampaignDetailsComponent,
    MapPlatformCampaigns as MapInPlatformCampaignsComponent,
    MergeCampaignsPanel
} from "./features/campaigns";

// Feature imports - Placements
import { PlacementDetailsTableService, PlacementTableAgGrid } from "./features/placements";

// Feature imports - Admin
import { 
    RatesAndFeesComponent, 
    ObjectsHierarchyComponent, 
    ObjectsHierarchyDetailsComponent, 
    VendorMappingComponent, 
    SystemParametersComponent,
    SystemParametersService
} from "./features/admin";

// Feature imports - Taxonomy
import { CreateTaxonomyComponent, CreateTaxonomyService } from "./features/taxonomy";

// Feature imports - Creatives
import { 
    OrphanedDeliveredObjectsComponent,
    CreateCreativeComponent,
    MapCreativeComponent
} from "./features/creatives";

// Feature imports - RFP
import { RfpDetailsTable } from "./features/rfp";
import AmplitudeEngagement from './shared/utils/AmplitudeEngagement';

export default function AppRoutes() {

    const location = useLocation();
    const navigate = useNavigate();

    const [spinnerCount, setSpinnerCount] = React.useState(1);
    const [placementTaxonomyData, setPlacementTaxonomyData] = React.useState();
    const [defaultTaxonomyData, setDefaultTaxonomyData] = React.useState();
    const [systemParametersData, setSystemParametersData] = React.useState({});
    const [campaignTaxonomyData, setCampaignTaxonomyData] = React.useState('');
    const [programmaticPackageTaxonomyData, setProgrammaticPackageTaxonomyData] = React.useState();
    const [programmaticPlacementTaxonomyData, setprogrammaticPlacementTaxonomyData] = React.useState();
    const [dspPackageTaxonomyData, setDspPackageTaxonomyData] = React.useState();
    const [creativePackageTaxonomyData, setCreativePackageTaxonomyData] = React.useState();
    const [searchPackageTaxonomyData, setSearchPackageTaxonomyData] = React.useState();
    const [directPackageTaxonomyData, setdirectPackageTaxonomyData] = React.useState();
    const [directLineTaxonomyData, setdirectLineTaxonomyData] = React.useState();
    const [directCreativeTaxonomyData, setDirectCreativeTaxonomyData] = React.useState();
    const [campaignName, setCampaignName] = React.useState('');
    const [navigatedCampaignObj, setNavigatedCampaignObj] = React.useState({});
    const [isRfpModalOpen, setIsRfpModalOpen] = React.useState(false);
    const [omniProfile, setOmniProfile] = React.useState();
    const [envIsLoaded, setEnvIsLoaded] = React.useState(false);
    const [checkTableValue, setCheckTableValue] = React.useState(false);
    const [placementName, setPlacementName] = React.useState();
    const [placementsData, setPlacementsData] = React.useState([]);
    const [creativeData, setCreativeData] = React.useState([]);
    const [openCreateTaxonomyPage, setOpenCreateTaxonomyPage] = React.useState(false);
    const [versionOneApi, setVersionOneApi] = React.useState("V2");
    const [seed, setSeed] = React.useState(1);
    const [campaignTableData, setCampaignTableData] = React.useState({});
    const [loadedCampaignData, setLoadedCampaignData] = React.useState([]);
    const [childCampaignIsCreated, setChildCampaignIsCreated] = React.useState(false);
    const [isPlacementSynced, setIsPlacementSynced] = React.useState(false);
    const [socialDirectPackageTaxonomyData, setSocialDirectPackageTaxonomyData] = React.useState({});
    const [socialDirectPlacementTaxonomyData, setSocialDirectPlacementTaxonomyData] = React.useState({});
    const [socialDirectLineTaxonomyData, setSocialDirectLineTaxonomyData] = React.useState({});
    const [socialDirectCreativeTaxonomyData, setSocialDirectCreativeTaxonomyData] = React.useState({});
    const [socialProgrammaticPackageTaxonomyData, setSocialProgrammaticPackageTaxonomyData] = React.useState();
    const [socialProgrammaticPlacementTaxonomyData, setSocialProgrammaticPlacementTaxonomyData] = React.useState();
    const [socialProgrammaticLineItemTaxonomyData, setSocialProgrammaticLineItemTaxonomyData] = React.useState();
    const [socialProgrammaticCreativeTaxonomyData, setSocialProgrammaticCreativeTaxonomyData] = React.useState();
    const [feeOrderTaxonomyData, setFeeOrderTaxonomyData] = React.useState({});
    const [networkTvPackageData, setNetworkTvPackageData] = React.useState();
    const [networkTvEstimateNameData, setNetworkTvEstimateNameData] = React.useState();
    const [offlinePackageData, setOfflinePackageData] = React.useState();
    const [offlineEstimateNameData, setOfflineEstimateNameData] = React.useState();
    const [oohPackageData, setoohPackageData] = React.useState();
    const [oohEstimateNameData, setoohEstimateNameData] = React.useState();
    const [parentCampaignObj, setParentCampaignObj] = React.useState();
    const [unMapCampaignObj, setUnMapCampaignObj] = React.useState();
    const [placementDisabled, setPlacementDisabled] = React.useState(false);
    const placementComponentRef = React.useRef(null);
    let [isMappingTable, setMappingTable] = React.useState();

    const allTaxonomyData = {};
    allTaxonomyData['defaultTaxonomyData'] = defaultTaxonomyData
    allTaxonomyData['programmaticPackageTaxonomyData'] = programmaticPackageTaxonomyData;
    allTaxonomyData['programmaticPlacementTaxonomyData'] = programmaticPlacementTaxonomyData;
    allTaxonomyData['dspPackageTaxonomyData'] = dspPackageTaxonomyData;
    allTaxonomyData['directPackageTaxonomyData'] = directPackageTaxonomyData;
    allTaxonomyData['placementTaxonomyData'] = placementTaxonomyData;
    allTaxonomyData['directLineTaxonomyData'] = directLineTaxonomyData;
    allTaxonomyData['creativePackageTaxonomyData'] = creativePackageTaxonomyData;
    allTaxonomyData['searchPackageTaxonomyData'] = searchPackageTaxonomyData;
    allTaxonomyData['feeOrderTaxonomyData'] = feeOrderTaxonomyData;
    allTaxonomyData['socialDirectPackageTaxonomyData'] = socialDirectPackageTaxonomyData;
    allTaxonomyData['socialDirectPlacementTaxonomyData'] = socialDirectPlacementTaxonomyData;
    allTaxonomyData['socialDirectLineTaxonomyData'] = socialDirectLineTaxonomyData;
    allTaxonomyData['socialDirectCreativeTaxonomyData'] = socialDirectCreativeTaxonomyData;
    allTaxonomyData['socialProgrammaticPackageTaxonomyData'] = socialProgrammaticPackageTaxonomyData;
    allTaxonomyData['socialProgrammaticPlacementTaxonomyData'] = socialProgrammaticPlacementTaxonomyData;
    allTaxonomyData['socialProgrammaticLineItemTaxonomyData'] = socialProgrammaticLineItemTaxonomyData;
    allTaxonomyData['socialProgrammaticCreativeTaxonomyData'] = socialProgrammaticCreativeTaxonomyData;
    allTaxonomyData['directCreativeTaxonomyData'] = directCreativeTaxonomyData;
    allTaxonomyData['feeOrderTaxonomyData'] = feeOrderTaxonomyData;
    allTaxonomyData['networkTvPackageData'] = networkTvPackageData;
    allTaxonomyData['networkTvEstimateNameData'] = networkTvEstimateNameData;
    allTaxonomyData['offlinePackageData'] = offlinePackageData;
    allTaxonomyData['offlineEstimateNameData'] = offlineEstimateNameData;
    allTaxonomyData['oohPackageData'] = oohPackageData;
    allTaxonomyData['oohEstimateNameData'] = oohEstimateNameData;
    allTaxonomyData['campaignTaxonomyData'] = campaignTaxonomyData;

    const permissions = {
        investor: ['enableSendToMO'],
        planner: ['enableSendToMO','enableApprovePlacements'],
        administrator: ['enableSendToMO', 'enableApprovePlacements', 'enableAdminOptions', 'pullFromBuyingSystem', 'enableTemplateEdit'],
        viewer: ['enableSendToMO', 'enableApprovePlacements'],
    };

    const checkPermissions = (roles, permission) => {
        return roles ? roles.some(role => permissions[role.toLowerCase()]?.includes(permission)) : false;
    };

    /**
     * Sets the client ID from a route parameter to a cookie.
     * If a client ID route parameter is found, it sets a cookie with the client ID.
     * @returns {void}
     */
    const setClientId = () => {        
        // Retrieves the 'clientid' route parameter from the URL
        let clientId = Utils.getRouteParam('clientid');
    if (clientId) {
        // Sets a cookie with the client ID
        CookieService.setCookie(clientId, 'clientId');
        sessionStorage.setItem('clientid', clientId);
    }
}

    // removing the queryparam from route after adding it to the cookie
    const removeRouteParamFromUrl = (queryNames) => {
        queryNames.forEach((queryName) => {
            const search = window.location.search;
            const params = new URLSearchParams(search);
            params.delete(queryName);
        });
    }

    // if they is no ansid or if ansid is invalid user will be redirected to login page
    const reDirectToLoginPage = () => {
        window.location = Constants.LoginRedirectUrl + Constants.MediaOpsDevUrl;
        CookieService.deleteAllCookie()
    }

    /**
     * The function `ValidateAnsid` checks if an ANsid is available in the URL or in a cookie, and
     * redirects to the login page if it is not available. If the ANsid is available, it retrieves the user
     * profile and performs various operations related to taxonomy data.
     */
    const ValidateAnsid = () => {
        let ANsid = Utils.getRouteParam('ANsid');
        const AnsidCookie = CookieService.getCookie("ANsid");

        if (ANsid) { // if ansi id is availbale in URL
            removeRouteParamFromUrl(['ANsid', 'clientid']);
            CookieService.setCookie(ANsid, 'ANsid');
            CookieService.setCookie(PlacementDetailsTableService.getDate(), 'LoginTime');
        } else if (AnsidCookie) { // if ANsid is not availble in URL but available in cookie
            ANsid = AnsidCookie;
        }

        if (!ANsid) {
            CookieService.setCookie('', 'LoginTime');
            reDirectToLoginPage();
        } else {
            MediaOpsService.getUserProfile().then(val => {
                if (val?.data?.personId) {
                    setOmniProfile(val && val.data);
                    CookieService.setCookie(JSON.stringify(val?.data), 'omniProfile');
                    initAmplitude(val?.data?.personId);
                    identifyUser(val?.data?.personId, {
                        email: val?.data?.email,
                        name: val?.data?.name,
                        role: val?.data?.role,
                    });
                    trackEvent('MediaOps is Intialized');
                    if (!CookieService.getCookie("LoginTime")) {
                        CookieService.setCookie(PlacementDetailsTableService.getDate(), 'LoginTime');
                    }
                } else {
                    CookieService.setCookie('', 'LoginTime');
                    reDirectToLoginPage();
                }
            }, (error) => {
                CookieService.setCookie('', 'LoginTime');
                reDirectToLoginPage();
            });
        }
    }

    const getallTaxonomiesList = () => {
        // displaying spinner for placement details table and create creatives page for loading taxonomies
        if (location?.pathname.includes('/placementDetailsTable') || location?.pathname.includes('/createCreatives')) {
            setSpinnerCount(1);
        }
        CreateTaxonomyService.getAllTaxonomyDataForDropdown().then((res) => {
            const response = Utils.removeDuplicateChildItems(res);
            let taxonomyMap = {};
            for(let i=0;i<response.length;i++){
                // Calculate total character limit from all fields character_limit value
                let totalCharLimit = 0;
                response[i].fields.forEach(field => {
                    totalCharLimit += field.character_limit || 0;
                });
                response[i].totalCharLimit = totalCharLimit;

                // Map taxonomy IDs to their respective taxonomy objects
                let taxonomyIds = response[i].taxonomy_type.split(',');
                for(let j=0;j<taxonomyIds.length;j++){
                    taxonomyMap[taxonomyIds[j]] = response[i];
                }
            }            
            setCampaignTaxonomyData(taxonomyMap[taxonomyTypes['campaign']]);
            setdirectPackageTaxonomyData(taxonomyMap[taxonomyTypes['directpackage']]);
            setPlacementTaxonomyData(taxonomyMap[taxonomyTypes['directplacement']]);
            setdirectLineTaxonomyData(taxonomyMap[taxonomyTypes['directline']]);
            setDirectCreativeTaxonomyData(taxonomyMap[taxonomyTypes['directcreative']]);
            setProgrammaticPackageTaxonomyData(taxonomyMap[taxonomyTypes['programmaticpackage']]);
            setprogrammaticPlacementTaxonomyData(taxonomyMap[taxonomyTypes['programmaticplacement']]);
            setDspPackageTaxonomyData(taxonomyMap[taxonomyTypes['programmaticline']]);
            setCreativePackageTaxonomyData(taxonomyMap[taxonomyTypes['programmaticcreative']]);
            setSearchPackageTaxonomyData(taxonomyMap[taxonomyTypes['search']]);
            setSocialDirectPackageTaxonomyData(taxonomyMap[taxonomyTypes['socialdirectpackage']])
            setSocialDirectPlacementTaxonomyData(taxonomyMap[taxonomyTypes['socialdirectplacement']])
            setSocialDirectLineTaxonomyData(taxonomyMap[taxonomyTypes['socialdirectlineitem']])
            setSocialDirectCreativeTaxonomyData(taxonomyMap[taxonomyTypes['socialdirectcreative']])
            setSocialProgrammaticPackageTaxonomyData(taxonomyMap[taxonomyTypes['socialprogrammaticpackage']])
            setSocialProgrammaticPlacementTaxonomyData(taxonomyMap[taxonomyTypes['socialprogrammaticplacement']])
            setSocialProgrammaticLineItemTaxonomyData(taxonomyMap[taxonomyTypes['socialprogrammaticlineitem']])
            setSocialProgrammaticCreativeTaxonomyData(taxonomyMap[taxonomyTypes['socialprogrammaticcreative']])      
            setFeeOrderTaxonomyData(taxonomyMap[taxonomyTypes['feeorder']])
            setNetworkTvPackageData(taxonomyMap[taxonomyTypes['networkttvpackage']])
            setNetworkTvEstimateNameData(taxonomyMap[taxonomyTypes['networktvestimatename']])
            setOfflinePackageData(taxonomyMap[taxonomyTypes['offlinepackage']])
            setOfflineEstimateNameData(taxonomyMap[taxonomyTypes['offlineestimatename']])
            setoohPackageData(taxonomyMap[taxonomyTypes['oohpackage']])
            setoohEstimateNameData(taxonomyMap[taxonomyTypes['oohestimatename']])
            setSeed(Math.random());
            setSpinnerCount(0);
        }, (error) => {
            setCampaignTaxonomyData({});
            setSpinnerCount(0);
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: getallTaxonomiesList, title: 'Taxonomy API cannot be loaded', bodyMsgArr: []}]);
        });
    }

    /**
     * The function retrieves default taxonomy data from an API and sets it in the state if it is not
     * already present.
     */
    const getDefaultTaxonomyData = () => {
        if (!defaultTaxonomyData) {
            if (location?.pathname !== '/') {
                setSpinnerCount(1);
            }
            MediaOpsService.getTaxonomy(taxonomyTypes['defaultplacement'])
                .then((response) => {
                    if (response)
                        response.typeID = taxonomyTypes['defaultplacement'];
                    setDefaultTaxonomyData(Utils.removeDuplicateChildItems([response])[0]);
                    setSeed(Math.random());
                    setSpinnerCount(0);
                }, (error) => {
                    setSpinnerCount(0);
                    AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: getDefaultTaxonomyData, title: 'Default Taxonomy API cannot be loaded', bodyMsgArr: [] }]);
                });
        }
    }

    const convertClientConfigurationData = (data) => data?.map(item => ({
        buyingSystem: item?.buying_system,
        clientCode: item?.client_code,
        "itemtype#name": item?.['itemtype#name'],
        market: item?.market,
        moAgencyId: item?.mo_agency_id,
        moOrganizationId: item?.mo_organization_id,
        name: item?.name
    }));
    
    /**
     * The function `fetchSystemParametersData` fetches system parameters data from an API and sets it in the state.
     * @returns {void}
     */
    const fetchSystemParametersData = (refreshSystemParameters = false) => {
        setSpinnerCount(1);
        SystemParametersService.fetchSystemParameters()
        .then((response) => {
            const latestItem = response?.length
                ? response.reduce((latest, item) =>
                    new Date(item?.updated_at) > new Date(latest?.updated_at) ? item : latest
                )
                : undefined;

            const data = {
                clientId: latestItem?.client_id,
                clientName: latestItem?.client_name,
                createdAt: latestItem?.created_at,
                createdBy: latestItem?.created_by,
                currency: latestItem?.currency,
                isActive: latestItem?.is_active,
                isApprovalRequired: latestItem?.is_approval_required,
                isCurrencyLocal: latestItem?.is_currency_local,
                isLocal: latestItem?.is_currency_local,
                isOptin: latestItem?.is_optin,
                showFlaggedFeature: latestItem?.show_flagged_feature,
                clientCode: convertClientConfigurationData(response),
                latestClientCode: convertClientConfigurationData([latestItem]),
                clientCodesFromAPI: response
            };

            setSeed(Math.random());
            setSystemParametersData({ isLoaded: true, data });
            setOpenCreateTaxonomyPage(!data?.isOptin);
            if (!refreshSystemParameters) {
                getDefaultTaxonomyData();
                getallTaxonomiesList();
            }
        }).catch((error) => {
            const errorMessage = error?.response?.data?.message || error?.response?.data?.errorMessage || error?.message || '';
            setSystemParametersData({isLoaded: false});
            AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: fetchSystemParametersData, title: 'Client configuration API cannot be loaded', bodyMsgArr: [errorMessage]}]);
        }).finally(() => {
            setSpinnerCount(0);
        });
    };

    const onComponentLoad = () => {
        window.omniUIStyles = {accessible: true};
        Utils.setBaseUrl().then(() => {
            setClientId();
            ValidateAnsid();
            setEnvIsLoaded(true);
            fetchSystemParametersData();
        });
    }
    
    React.useEffect(() => {
        onComponentLoad();
    }, []);

    React.useEffect(() => {
        Utils.saveRouteChange(location.pathname);
        // Clear navigation stack when on home page
        if (location.pathname === '/') {
            NavigationStack.clear();
        }
    }, [location.pathname]);

    /**
     * The function `openSettings` toggles the class 'is-active' on the element with the id
     * 'settings-container' to show or hide the settings container.
     */
    const openSettings = () => {
        const settingsContainer = document.querySelector("#settings-container");
        if (settingsContainer.classList.contains('is-active')) {
            settingsContainer.classList.remove('is-active');
        } else {
            settingsContainer.classList.toggle('is-active');
        }
    }

    /** 
    * The function `openScreen` opens a specific screen using Utils.navigateToComponent()
    * @param {String} screenName - The screen name to navigate.
    */
     const openScreen = (screenName) => {
        let currentCampaign = '';
        if(systemParametersData?.data?.showFlaggedFeature && location.state?.parentCampaign){
            currentCampaign = location.state?.parentCampaign;
        } else {
            currentCampaign = location.state?.campaignObj;
        }
        Utils.navigateToComponent(currentCampaign, screenName, {navigate, location});
    }

    /**
     * The function `openMapCreativeScreen` opens a specific screen using Utils.navigateToComponent()
     * @param {String} screenName - The screen name to navigate.
     */
    const openMapCreativeScreen = (screenName) => {
        let currentCampaign = location.state?.campaignObj;
        if(currentCampaign.placementData?.length){
            Utils.navigateToComponent(currentCampaign, screenName, {navigate, location});
        } else {
            AlertMessagesService.showWarningToastMessage(`Please create package and/or placements to continue mapping creatives.`);
        }
    }

    /**
     * The function `navigateToCreateTaxonomy` sets the placement name and navigates to a specific URL.
     * @param placement - The `placement` parameter is an object that represents a placement in a campaign.
     * It likely has properties such as `placement_taxonomy` and `id`.
     * @param campaignObj - An object representing a campaign. It likely has properties such as `id`,
     * `name`, `startDate`, `endDate`, etc.
     */
    const navigateToCreateTaxonomy = (placement, campaignObj) => {
        setPlacementName(placement?.placement_taxonomy);
        let campaignId = encodeURIComponent(campaignObj?.id);
        let placementId = encodeURIComponent(placement?.id);
        let placementsNameId = encodeURIComponent(placement?.placements_id);
        NavigationStack.push(window.location.pathname, location.state);
        navigate(`/createTaxonomy/${campaignId}/${placementId}/${placementsNameId}`);
    }

    /**
     * The function `openPath` navigates to a specific path and opens the settings container.
     * @param {String} path - The path to navigate to.
     * @returns {void}
     */
    const openPath = (path) => {
        NavigationStack.push(window.location.pathname, location.state);
        navigate(path);
        openSettings();
    }


    /**
     * Displays a confirmation dialog to the user before pulling data from the buying system.
     *
     * This function shows a confirmation dialog with a warning message. If the user confirms,
     * it calls the `handleCampaignSync` function to initiate the data pull from the buying system.
     *
     * @returns {void}
     */
    const campaignSyncWarningMessage = () => {
        const confirmMessage = `Are you sure you want to pull data from buying system?`
        om2confirm(confirmMessage, {
            callback: () => handleCampaignSync(),
            type: "warning",
            title: `Pull Data From Buying System`,
        });
    }

    /**
     * The function `handleCampaignSync` sends a request to the API to sync the campaign data.
     * If the request is successful, it sets the child campaign as created and shows a success message.
     * If the request fails, it shows an error message.
     * @returns {void}
     */
    const handleCampaignSync = () => {
        setSpinnerCount(1);
        MediaOpsService.campaignSync()
        .then((response) => {
            setSpinnerCount(0);
            const message = response?.data ? response?.data['message'] || response?.data['message '] : {};
            if(response?.data?.status === 'error'){ // Showing error message if status is error and success message if status is success
                AlertMessagesService.showMultipleAlerts([{type:"danger", retryBtnText: 'Retry', retryBtnEvent: () => handleCampaignSync(), title:`${message?.code} - Unable to sync campaign`,"bodyMsgArr":[message?.message]}]);
            } else {
                setChildCampaignIsCreated(true);
                MediaOpsService.campaignSyncStatus({sync_id:response?.data?.sync_id}).then((response) => {
                    // For future purpose, hence commenting it
                    // if(response?.data?.status !== 'error'){
                    //     AlertMessagesService.showSuccessToastMessage(`Campaign sync status ...`);
                    // }
                });
                AlertMessagesService.showSuccessToastMessage(`Campaign sync has been started. Please check back in a while.`);
            };
        }).catch((error) => {
            setSpinnerCount(0);
            const statusCode = error?.response?.status
            const errorMessage = error?.response?.data?.message || error?.response?.data?.errorMessage || error?.message;
            if(statusCode === 504){
                AlertMessagesService.showSuccessToastMessage(`Campaign sync is happening in the background and it need a bit of time. Please refresh after few minutes.`);
            } else{
                AlertMessagesService.showMultipleAlerts([{type:"danger", retryBtnText: 'Retry', retryBtnEvent: () => handleCampaignSync(), title:`${statusCode} - Unable to sync campaign`,"bodyMsgArr":[errorMessage]}])
            }
        })
    };

    /**
     * Displays a confirmation dialog to the user before pulling data from the buying system.
     *
     * This function shows a confirmation dialog with a warning message. If the user confirms,
     * it calls the `placementSync` function to initiate the data pull from the buying system.
     *
     * @returns {void}
     */
    const placementSyncWarningMessage = () => {
        const confirmMessage = `Are you sure you want to pull data from buying system?`
        om2confirm(confirmMessage, {
            callback: () => placementSync(),
            type: "warning",
            title: `Pull Data From Buying System`,
        });
    }

    const placementSync = () => {
        setSpinnerCount(1);
        const payload = {userEmail: omniProfile?.email};
        const isPlanit = navigatedCampaignObj?.source?.toLocaleLowerCase() === 'planit';
        const syntheticId = isPlanit ?  encodeURIComponent(navigatedCampaignObj?.amd_campaign_id) : encodeURIComponent(navigatedCampaignObj?.synthetic_id);
        MediaOpsService.placementSyncV2(syntheticId, payload)
        .then((response) => {
            const message = response?.data ? response?.data['message'] || response?.data['message '] : {};
            if(response?.data?.status === 'error'){ // Showing error message if status is error and success message if status is success
                AlertMessagesService.showMultipleAlerts([{type:"danger", retryBtnText: 'Retry', retryBtnEvent: () => placementSync(), title:`${message?.code} - Unable to sync placements`,"bodyMsgArr":[message?.message]}]);
                setSpinnerCount(0);
            } else {
                setIsPlacementSynced(true);
                const updatedPlacmentCount = response?.data?.filter((placement) => placement?.status?.toLowerCase() === 'updated')?.length;
                const addedPlacmentCount = response?.data?.filter((placement) => placement?.status?.toLowerCase() === 'added')?.length;
                AlertMessagesService.showSuccessToastMessage(`Placement sync is successful, ${updatedPlacmentCount} placements updated and ${addedPlacmentCount} placements added.`);

                if (placementComponentRef?.current) {
                    placementComponentRef?.current?.loadPlacements(true);
                } else {
                    setSpinnerCount(0);
                }
            };
        })
        .catch((error) => {
            setSpinnerCount(0);
            if(error?.response?.status === 504){
                AlertMessagesService.showSuccessToastMessage(`Placement sync is happening in the background and it need a bit of time. Please refresh after few minutes.`);
            } else{
                AlertMessagesService.showMultipleAlerts([{type:"danger", retryBtnText: 'Retry', retryBtnEvent: () => placementSync(), title:`500 - Unable to sync placements`,"bodyMsgArr":[error?.message]}])
            }
        })
    };

    /**
     * Navigates back to the previous page using NavigationStack.
     * Falls back to home page if no history exists.
     */
    const navigateBack = () => {
        const previousLocation = NavigationStack.pop();
        
        if (previousLocation) {
            navigate(previousLocation.pathname, { state: previousLocation.state });
        } else {
            // No history, navigate to home
            setParentCampaignObj();
            navigate('/');
        }
    }

     /**
     * Close download modal, timer
     * @param {number} timer is when download button , it will first let download and then close
     */
    const closeExportModal = (timer=0) => {
        setTimeout(() => {
            let omniDialogEl = document.getElementById('export-placement-dialog'); 
            omniDialogEl.close()
        }, timer);
    }

    return (
       <>
            <div className="appRouteHeader">
                <div style={{width: isMappingTable ? '63.5%' : '100%',transition: '0.5s',}}>
            <AmplitudeEngagement />
            {(
                <div className="appHeader" style={{width: isMappingTable ? '63.5%' : '100%',transition: '0.5s',}}>

                    {(openCreateTaxonomyPage && location.pathname === '/') && <span>Create Taxonomy</span>}
                    {(!openCreateTaxonomyPage && location.pathname === '/') && <span>Campaigns</span>}

                    {(!openCreateTaxonomyPage && location.pathname !== '/')&&
                        <div>
                            <OmniTooltipNextComponent place="right">
                                <button onClick={navigateBack} className="goBackButton tertiary" slot="invoker" aria-haspopup="true">
                                    <OmniIconComponent className="is-size-4 backIcon" icon-id="omni:interactive:back"></OmniIconComponent>
                                </button>
                                {(location.pathname.includes('/objectsHierarchyDetails')) ?
                                <div slot="content">Back to Objects Hierarchy Table</div>
                                : (location.pathname.includes('/orphanedDeliveredObjects')) ?
                                <div slot="content">Back to Placements Table</div>
                                : <div slot="content">Back to Campaigns</div>
                                }
                            </OmniTooltipNextComponent>
                            {(location.pathname.includes('/campaignDetails') || location.pathname.includes('/placementDetailsTable') || location.pathname.includes('/rfpDetailsTable') 
                            || location.pathname.includes('/orphanedDeliveredObjects') || location.pathname.includes('/createCreatives') || location.pathname.includes('/mapCreatives'))
                            && <span>{campaignName}</span>}
                            {(location.pathname.includes('/ratesAndFees')) && <span>Rates And Fees</span>}
                            {(location.pathname.includes('/objectsHierarchy')) && <span>Objects Hierarchy</span>}
                            {(location.pathname.includes('/createTaxonomy')) && <span>{placementName}</span>}
                            {(location.pathname.includes('/vendorMapping')) && <span>Vendor Mappings</span>}
                            {(location.pathname.includes('/systemParameters')) && <span>System Parameters</span>}
                            {(location.pathname === '/mapInPlatformCampaigns') && <span>Campaigns</span>}
                        </div>
                    }
                    <div className="header-setting-section">
                    
                        <div className="buttonContainer">
                        {(location.pathname === '/') && checkPermissions(omniProfile?.project?.userRoles,'pullFromBuyingSystem') &&
                        (<button className="secondary" onClick={campaignSyncWarningMessage}>Pull Data From Buying System</button>)}

                        {(location.pathname.includes('/placementDetailsTable')) && checkPermissions(omniProfile?.project?.userRoles,'pullFromBuyingSystem') &&
                        (<button className="secondary"  disabled={!navigatedCampaignObj?.mediaocean_id} onClick={placementSyncWarningMessage}>Pull Data From Buying System</button>)}
                        
                        {location.pathname.includes('/rfpDetailsTable') && checkTableValue &&
                        <>
                            <button className="secondary" onClick={() => { setIsRfpModalOpen(true) }}>Create RFP</button>
                        </>}

                        {location.pathname.includes('/placementDetailsTable') &&
                        <>
                            <button className="secondary" disabled={!placementsData.length} onClick={() => openScreen('orphanedDeliveredObjects')}>Map In Platform Objects</button>
                        </>}

                        {location.pathname === '/' &&
                        <>
                            <button className="secondary" disabled={!loadedCampaignData.length} onClick={() => { NavigationStack.push(window.location.pathname, location.state); navigate('mapInPlatformCampaigns'); }}>Map In Platform Campaigns</button>
                        </>}
                        {/* {unMapCampaignObj && unMapCampaignObj?.length > 0 && !isMappingTable && location.pathname === '/' &&
                        <>
                            <button className="secondary campaign-badge" onClick={() => setMappingTable(true)}>
                                <omni-icon class="is-size-1 alert-icon" icon-id="icon:informative:alert"></omni-icon>
                                Campaign Mapping Required
                                <div className="un-map-campaignnotification" role="status">{unMapCampaignObj.length}</div>
                            </button>
                        </>} */}
                            {/* <omni-badge class="is-size-7" id="sub1" level="omni professional">3</omni-badge> */}
                        {/* {unMapCampaignObj && unMapCampaignObj?.length > 0 && isMappingTable && location.pathname === '/' &&
                        <>  
                            <button className="secondary" onClick={() => setMappingTable(false)}>
                                <omni-icon icon-id="icon:interactive:back"></omni-icon>
                                Back
                            </button>
                        </>} */}

                        {location.pathname.includes('/createCreatives') &&
                        <>
                            <button className="secondary" onClick={() => openMapCreativeScreen('mapCreatives')}>Map Creatives</button>
                        </>}

                        {location.pathname.includes('/campaignDetails') &&
                        <>
                            <button className="secondary open-placement-button" onClick={() => { openScreen('placementDetailsTable') }} disabled={placementDisabled || systemParametersData?.data?.showFlaggedFeature}>Open Placements</button>
                            <button className="secondary open-placement-button" onClick={() => { openScreen('createCreatives') }}>Manage Creative</button>
                            {/* Commenting out the RFP feature for now. Please uncomment it once the business confirms the requirement in the future.*/}
                            {/* <button className="button is-medium is-outlined" onClick={() => { openScreen('rfpDetailsTable') }}>Open RFP</button> */}
                        </>}
                        </div>   
                        
                        {checkPermissions(omniProfile?.project?.userRoles,'enableAdminOptions') && 
                            <>
                                <span className="toolbar-divider"/>
                                {!openCreateTaxonomyPage &&
                                    <div className="dropdown" id="settings-container">
                                        <div>
                                            <OmniIconComponent className="is-size-4 settingsIcon" icon-id="omni:informative:settings" onClick={openSettings}></OmniIconComponent>
                                        </div>
                                        <div part="dropdown-menu" className="dropdown-menu" id="dropdown-menu" role="menu">
                                            <div className="dropdown-content">
                                                {/* <a className={`dropdown-item`} onClick={() => openPath(`/vendorMapping/${Utils.getRouteParam("clientid")}`)}>Vendor Mappings</a> */}
                                                <a className={`dropdown-item`} onClick={() => openPath(`/objectsHierarchy/${Utils.getRouteParam("clientid")}`)}>Objects Hierarchy</a>
                                                {/* <a className={`dropdown-item`} onClick={() => openPath(`/ratesAndFees/${Utils.getRouteParam("clientid")}`)}>Rates And Fees</a> */}
                                                <a className={`dropdown-item`} onClick={() => openPath(`/systemParameters/${Utils.getRouteParam("clientid")}`)}>System Parameters</a>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </>
                        } 

                    </div>
                </div>
            )}



            <LoaderComponent spinnerCount={spinnerCount} displayWholePage={true} />
            {/* In <Route> path component/Tag , and inside component tag sending params that we will recevie inside component as Props */}
            {envIsLoaded && 
                <div className="appContainer">
                    <Routes>
                        {(omniProfile && !openCreateTaxonomyPage && systemParametersData?.data && Object.keys(systemParametersData?.data)?.length) && 
                            // <Route path="/" element={ !systemParametersData?.data?.showFlaggedFeature ? 
                            // <CampaignTableAgGridV1 systemParametersData={systemParametersData} setChildCampaignIsCreated={setChildCampaignIsCreated} childCampaignIsCreated={childCampaignIsCreated} setCampaignTableData={setCampaignTableData} setUnMapCampaignObj={setUnMapCampaignObj} unMapCampaignObj={unMapCampaignObj} campaignTableData={campaignTableData} setLoadedCampaignData={setLoadedCampaignData} 
                            // navigate={navigate} setSpinnerCount={setSpinnerCount} omniProfile={omniProfile} versionOneApi={versionOneApi} isMappingTable = {isMappingTable} setMappingTable={setMappingTable} spinnerCount={spinnerCount}/> 
                            //     : 
                            // <CampaignTableAgGridV2 systemParametersData={systemParametersData} setChildCampaignIsCreated={setChildCampaignIsCreated} childCampaignIsCreated={childCampaignIsCreated} setCampaignTableData={setCampaignTableData} setUnMapCampaignObj={setUnMapCampaignObj} unMapCampaignObj={unMapCampaignObj} campaignTableData={campaignTableData} setLoadedCampaignData={setLoadedCampaignData} 
                            // navigate={navigate} setSpinnerCount={setSpinnerCount} omniProfile={omniProfile} versionOneApi={systemParametersData?.data?.showFlaggedFeature ? 'V3' : versionOneApi} isMappingTable = {isMappingTable} setMappingTable={setMappingTable} />} />
                            <Route path="/" element={<CampaignTableAgGridV1 systemParametersData={systemParametersData} setChildCampaignIsCreated={setChildCampaignIsCreated} childCampaignIsCreated={childCampaignIsCreated} setCampaignTableData={setCampaignTableData} setUnMapCampaignObj={setUnMapCampaignObj} unMapCampaignObj={unMapCampaignObj} campaignTableData={campaignTableData} setLoadedCampaignData={setLoadedCampaignData} 
                            navigate={navigate} setSpinnerCount={setSpinnerCount} omniProfile={omniProfile} versionOneApi={versionOneApi} isMappingTable = {isMappingTable} setMappingTable={setMappingTable} spinnerCount={spinnerCount}/> } />
                        }

                        {defaultTaxonomyData && <Route path="/ratesAndFees/:clientId" element={<RatesAndFeesFunctionalComponent defaultTaxonomyData={defaultTaxonomyData} navigate={navigate} setSpinnerCount={setSpinnerCount} omniProfile={omniProfile}/>} />}

                        {(MediaOpsService.hasNonEmptyValue(defaultTaxonomyData) || MediaOpsService.hasNonEmptyValue(allTaxonomyData)) &&
                            <Route path="/createTaxonomy/:campaignId/:placementId/:placementSyntheticId" element={<CreateTaxonomyFunctionalComponent allTaxonomyData={allTaxonomyData} navigate={navigate} setSpinnerCount={setSpinnerCount} omniProfile={omniProfile} placementName={placementName} setPlacementName={setPlacementName} versionOneApi={versionOneApi}/>} />}

                        {openCreateTaxonomyPage &&
                            <Route path="/" element={<CreateTaxonomyFunctionalComponent openCreateTaxonomyPage={openCreateTaxonomyPage} allTaxonomyData={allTaxonomyData} navigate={navigate} setSpinnerCount={setSpinnerCount} omniProfile={omniProfile} />} />}

                            
                            <Route path="/objectsHierarchy/:clientId" element={<ObjectsHierarchyFunctionalComponent navigate={navigate} setSpinnerCount={setSpinnerCount} omniProfile={omniProfile}/>} />
                            <Route path="/objectsHierarchyDetails/:campaignId" element={<ObjectsHierarchyDetailsFunctionalComponent navigate={navigate} setSpinnerCount={setSpinnerCount} omniProfile={omniProfile}/>} />
                            {/* <Route path="/vendorMapping/:clientId" element={<VendorMappingFunctionalComponent navigate={navigate} setSpinnerCount={setSpinnerCount} omniProfile={omniProfile}/>} /> */}
                            <Route path="/systemParameters/:clientId" element={<SystemParametersFunctionalComponent navigate={navigate} spinnerCount={spinnerCount} setSpinnerCount={setSpinnerCount} omniProfile={omniProfile} systemParametersData={systemParametersData} setSystemParametersData={setSystemParametersData} fetchSystemParametersData={fetchSystemParametersData} />} />

                            {(campaignTaxonomyData !== undefined && defaultTaxonomyData) && 
                            <Route path="/mapInPlatformCampaigns" 
                            element={<MapInPlatformCampaignsComponentFunctionalComponent
                            navigate={navigate}
                            omniProfile={omniProfile}
                            versionOneApi={versionOneApi}
                            setSpinnerCount={setSpinnerCount}
                            setCampaignName={setCampaignName}
                            loadedCampaignData={loadedCampaignData}
                        />} /> 
                        }
                        
                        {campaignTaxonomyData && Object.keys(campaignTaxonomyData).length &&
                            <Route path="/campaignDetails/:campaignId" element={<CampaignDetailFunctionalComponent
                                campaignTaxonomyData={campaignTaxonomyData}
                                navigate={navigate}
                                location={location}
                                setCampaignName={setCampaignName}
                                setSpinnerCount={setSpinnerCount}
                                omniProfile={omniProfile}
                                versionOneApi={versionOneApi}
                                setCampaignTableData={setCampaignTableData}
                                systemParametersData={systemParametersData}
                                setParentCampaignObj={setParentCampaignObj}
                                parentCampaignObj={parentCampaignObj}
                                spinnerCount={spinnerCount}
                                setPlacementDisabled={setPlacementDisabled}
                            />} />
                        }

                        {(campaignTaxonomyData !== '' && !Object.keys(campaignTaxonomyData).length) &&
                            <Route path="/campaignDetails/:campaignId" element={<NoDataComponent 
                                heading={"Couldn't load campaign details"}
                                message={"The taxonomy schema could not be found for this campaign. Please reload or try again later."}
                                isButton={true}
                                setSpinnerCount={setSpinnerCount}
                            />}/>
                        }

                        {campaignTaxonomyData && Object.keys(campaignTaxonomyData).length &&
                            <Route path="/campaignDetails/createChildCampaign/:campaignId" element={<ChildCampaignDetailsFunctionalComponent
                                campaignTaxonomyData={campaignTaxonomyData}
                                navigate={navigate}
                                location={location}
                                setChildCampaignIsCreated={setChildCampaignIsCreated}
                                setCampaignName={setCampaignName}
                                setSpinnerCount={setSpinnerCount}
                                omniProfile={omniProfile}
                                versionOneApi={versionOneApi}
                                setCampaignTableData={setCampaignTableData}
                                systemParametersData={systemParametersData}
                            />} />
                        }

                        {defaultTaxonomyData && 
                            <Route path="/placementDetailsTable/:campaignId/:channelName?/:supplierName?" 
                            element={<PlacementDetailsTableFunctionalComponent
                            isPlacementSynced={isPlacementSynced}
                            setIsPlacementSynced={setIsPlacementSynced}
                            navigateToCreateTaxonomy={navigateToCreateTaxonomy}
                            omniProfile={omniProfile}
                            allTaxonomyData={allTaxonomyData}
                            campaignTaxonomyData={campaignTaxonomyData}
                            navigate={navigate}
                            setCampaignName={setCampaignName}
                            setNavigatedCampaignObj={setNavigatedCampaignObj}
                            setSpinnerCount={setSpinnerCount}
                            setPlacementsData={setPlacementsData}
                            placementsData={placementsData}
                            checkPermissions={checkPermissions}
                            versionOneApi={versionOneApi}
                            systemParametersData={systemParametersData}
                            ref={placementComponentRef}
                            location={location}
                            key={seed}
                        ></PlacementDetailsTableFunctionalComponent>} /> 
                        }
                         
                        {(placementTaxonomyData !== undefined && defaultTaxonomyData) && 
                            <Route path="/orphanedDeliveredObjects/:campaignId" 
                            element={<OrphanedDeliveredObjectsFunctionalComponent
                            navigate={navigate}
                            omniProfile={omniProfile}
                            placementsData={placementsData}
                            setSpinnerCount={setSpinnerCount}
                            setCampaignName={setCampaignName}
                            versionOneApi={versionOneApi}
                            location={location}
                        />} /> 
                        }

                        {placementTaxonomyData !== undefined && defaultTaxonomyData &&
                        <Route path="/createCreatives/:campaignId" element={<CreateCreativeFunctionalComponent 
                            allTaxonomyData={allTaxonomyData} 
                            navigate={navigate} 
                            setSpinnerCount={setSpinnerCount} 
                            setCampaignName={setCampaignName}
                            setCreativeData={setCreativeData}
                            creativeData={creativeData}
                            omniProfile={omniProfile} 
                            location={location}
                            systemParametersData={systemParametersData}
                            />} 
                        />}

                        {placementTaxonomyData !== undefined && defaultTaxonomyData &&
                        <Route path="/mapCreatives/:campaignId" element={<MapCreativeFunctionalComponent 
                            allTaxonomyData={allTaxonomyData} 
                            navigate={navigate} 
                            setSpinnerCount={setSpinnerCount} 
                            setCampaignName={setCampaignName}
                            creativeData={creativeData}
                            omniProfile={omniProfile} 
                            location={location}
                            />} 
                        />}

                        <Route path="/rfpDetailsTable/:campaignId" element={<RfpDetailsFunctionalComponent
                            isRfpModalOpen={isRfpModalOpen}
                            setIsRfpModalOpen={setIsRfpModalOpen}
                                omniProfile={omniProfile}
                                navigate={navigate}
                                location={location}
                                setCampaignName={setCampaignName}
                                setSpinnerCount={setSpinnerCount}
                                setCheckTableValue= {setCheckTableValue}
                                versionOneApi={versionOneApi}
                            ></RfpDetailsFunctionalComponent>} /> 
                    </Routes>

                </div>
            }
             {/* for Export download, common file need open on any page */}
            <omni-modal id="export-placement-dialog" className="export-download-modal">
                <div className="export-header" style={{'display': 'flex','justifyContent': 'space-between','flexDirection': 'row',' alignItems': 'center', 'borderBottom': '1px solid #EDF0F5'}}>
                    <span slot="header" className="is-size-4 p-4">Your File is Ready!</span>
                    <span slot="header" className="is-size-4 p-4" onClick={()=>closeExportModal()}>
                        <omni-icon
                            icon-id="omni:interactive:close"
                            aria-hidden="false">
                        </omni-icon>
                    </span>
                </div>
                <div className="separater"></div>
                <p className="is-size-5 p-4">Download to save the file.</p>
                <span slot="footer" id="export-placement-dialog-footer" className="is-size-2 modal-footer" style={{'display': 'flex','justifyContent': 'flex-end','flexDirection': 'row',' alignItems': 'center'}}>
                    <a className="button is-text" onClick={()=>closeExportModal()}  style={{'paddingRight': '24px'}}>Cancel</a>
                    <a id="export-placement-download-btn" className="button" onClick={()=>closeExportModal(1000)} >Download</a>
                </span>
            </omni-modal>
        </div>
        {unMapCampaignObj && unMapCampaignObj.length > 0 &&
                    <div className="mapping-side-panel" style={{
                                width: isMappingTable ? '36.5%' : '0%',
                            }}>

                        <MergeCampaignsPanel
                            omniProfile={omniProfile}
                            unMapCampaign={unMapCampaignObj}
                            systemParametersData={systemParametersData}
                            isMappingTable = {isMappingTable}
                            setMappingTable={setMappingTable}
                            setUnMapCampaignObj={setUnMapCampaignObj}
                            setSpinnerCount={setSpinnerCount}
                        />
                    </div>
                }
            </div>
        </>
    );
}

// creating functional component wrapper to pass params and location from the router:

const CampaignDetailFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    if(props.systemParametersData?.data?.showFlaggedFeature){
        return <CampaignDetailComponentV2 state={location?.state} params={params} {...props} />
    } else {
        return <CampaignDetailComponent state={location?.state} params={params} {...props} />
    }
}

const ChildCampaignDetailsFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <ChildCampaignDetailsComponent state={location?.state} params={params} {...props} />
}

const PlacementDetailsTableFunctionalComponent = React.forwardRef((props, ref) => {
    const location = useLocation();
    const params = useParams();
    return <PlacementTableAgGrid state={location?.state} params={params} {...props} ref={ref} />;
});

const RfpDetailsFunctionalComponent = props => {
  const location = useLocation()
  const params = useParams()
  return <RfpDetailsTable state={location?.state} params={params} {...props}></RfpDetailsTable>
}

const RatesAndFeesFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <RatesAndFeesComponent state={location?.state} params={params} {...props}></RatesAndFeesComponent>
}

const CreateTaxonomyFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <CreateTaxonomyComponent state={location?.state} params={params} {...props}></CreateTaxonomyComponent>
}

const CreateCreativeFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <CreateCreativeComponent state={location?.state} params={params} {...props}></CreateCreativeComponent>
}

const MapCreativeFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <MapCreativeComponent state={location?.state} params={params} {...props}></MapCreativeComponent>
}

// creating functional component wrapper to pass params and location from the router:
const ObjectsHierarchyFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <ObjectsHierarchyComponent state={location?.state} params={params} {...props}/>
}

// creating functional component wrapper to pass params and location from the router:
const ObjectsHierarchyDetailsFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <ObjectsHierarchyDetailsComponent state={location?.state} params={params} {...props}/>
}

// The functional component wrapper for the SystemParametersComponent.
const SystemParametersFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <SystemParametersComponent state={location?.state} params={params} {...props}/>
}

// creating functional component wrapper to pass params and location from the router:
const OrphanedDeliveredObjectsFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <OrphanedDeliveredObjectsComponent state={location?.state} params={params} {...props}/>
};

// creating functional component wrapper to pass params and location from the router:
const MapInPlatformCampaignsComponentFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <MapInPlatformCampaignsComponent state={location?.state} params={params} {...props}/>
};

const VendorMappingFunctionalComponent = props => {
    const location = useLocation();
    const params = useParams();
    return <VendorMappingComponent state={location?.state} params={params} {...props}/>
}